/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SiloGovernanceToken,
  SiloGovernanceTokenInterface,
} from "../SiloGovernanceToken";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromDelegate",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "toDelegate",
        type: "address",
      },
    ],
    name: "DelegateChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegate",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "previousBalance",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBalance",
        type: "uint256",
      },
    ],
    name: "DelegateVotesChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "pos",
        type: "uint32",
      },
    ],
    name: "checkpoints",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "fromBlock",
            type: "uint32",
          },
          {
            internalType: "uint224",
            name: "votes",
            type: "uint224",
          },
        ],
        internalType: "struct ERC20Votes.Checkpoint",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegatee",
        type: "address",
      },
    ],
    name: "delegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegatee",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "delegateBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "delegates",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getPastTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getPastVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "numCheckpoints",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x6101606040527f6e71edae12b1b97f4d1f60370fef10105fa2faae0126114a169c64845d6126c9610140523480156200003757600080fd5b506040518060400160405280601381526020017f53696c6f476f7665726e616e6365546f6b656e0000000000000000000000000081525080604051806040016040528060018152602001603160f81b8152506040518060400160405280601581526020017f53696c6f20476f7665726e616e636520546f6b656e00000000000000000000008152506040518060400160405280600481526020016353696c6f60e01b8152508160039080519060200190620000f49291906200083c565b5080516200010a9060049060208401906200083c565b5050506200012762000121620001e660201b60201c565b620001ea565b815160209283012081519183019190912060e08290526101008190524660a0818152604080517f8b73c3c69bb8fe3d512ecc4cf759cc79239f7b179b0ffacaa9a75d522b39400f818801819052818301969096526060810194909452608080850193909352308483018190528151808603909301835260c0948501909152815191909501209052919091526101205250620001e033620001ca6012600a620009eb565b620001da90633b9aca00620009fc565b6200023c565b62000aa5565b3390565b600580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6200025382826200025760201b62000d391760201c565b5050565b6200026e82826200030e60201b62000dc91760201c565b6001600160e01b0362000282620003fd8216565b1115620002ef5760405162461bcd60e51b815260206004820152603060248201527f4552433230566f7465733a20746f74616c20737570706c79207269736b73206f60448201526f766572666c6f77696e6720766f74657360801b60648201526084015b60405180910390fd5b62000308600962000eb06200040360201b17836200041a565b50505050565b6001600160a01b038216620003665760405162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f2061646472657373006044820152606401620002e6565b80600260008282546200037a919062000a1e565b90915550506001600160a01b03821660009081526020819052604081208054839290620003a990849062000a1e565b90915550506040518181526001600160a01b038316906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200160405180910390a36200025360008383620005d1565b60025490565b600062000411828462000a1e565b90505b92915050565b8254600090819080156200046c57856200043660018362000a39565b8154811062000449576200044962000a53565b60009182526020909120015464010000000090046001600160e01b03166200046f565b60005b6001600160e01b031692506200048683858760201c565b9150600081118015620004ca57504386620004a360018462000a39565b81548110620004b657620004b662000a53565b60009182526020909120015463ffffffff16145b156200053e57620004e682620005e960201b62000ebc1760201c565b86620004f460018462000a39565b8154811062000507576200050762000a53565b9060005260206000200160000160046101000a8154816001600160e01b0302191690836001600160e01b03160217905550620005c3565b85604051806040016040528062000560436200065860201b62000f291760201c565b63ffffffff1681526020016200058185620005e960201b62000ebc1760201c565b6001600160e01b0390811690915282546001810184556000938452602093849020835194909301519091166401000000000263ffffffff909316929092179101555b50935093915050565b505050565b620005cc838383620006bf60201b62000f8e1760201c565b60006001600160e01b03821115620006545760405162461bcd60e51b815260206004820152602760248201527f53616665436173743a2076616c756520646f65736e27742066697420696e20326044820152663234206269747360c81b6064820152608401620002e6565b5090565b600063ffffffff821115620006545760405162461bcd60e51b815260206004820152602660248201527f53616665436173743a2076616c756520646f65736e27742066697420696e203360448201526532206269747360d01b6064820152608401620002e6565b620006d7838383620005cc60201b620007c81760201c565b6001600160a01b03838116600090815260076020526040808220548584168352912054620005cc92918216911683818314801590620007165750600081115b15620005cc576001600160a01b03831615620007a3576001600160a01b0383166000908152600860209081526040822082916200076091906200082e901b62000fc017856200041a565b91509150846001600160a01b031660008051602062002b94833981519152838360405162000798929190918252602082015260400190565b60405180910390a250505b6001600160a01b03821615620005cc576001600160a01b038216600090815260086020908152604082208291620007e7919062000403901b62000eb017856200041a565b91509150836001600160a01b031660008051602062002b9483398151915283836040516200081f929190918252602082015260400190565b60405180910390a25050505050565b600062000411828462000a39565b8280546200084a9062000a69565b90600052602060002090601f0160209004810192826200086e5760008555620008b9565b82601f106200088957805160ff1916838001178555620008b9565b82800160010185558215620008b9579182015b82811115620008b95782518255916020019190600101906200089c565b50620006549291505b80821115620006545760008155600101620008c2565b634e487b7160e01b600052601160045260246000fd5b600181815b808511156200092f578160001904821115620009135762000913620008d8565b808516156200092157918102915b93841c9390800290620008f3565b509250929050565b600082620009485750600162000414565b81620009575750600062000414565b81600181146200097057600281146200097b576200099b565b600191505062000414565b60ff8411156200098f576200098f620008d8565b50506001821b62000414565b5060208310610133831016604e8410600b8410161715620009c0575081810a62000414565b620009cc8383620008ee565b8060001904821115620009e357620009e3620008d8565b029392505050565b60006200041160ff84168362000937565b600081600019048311821515161562000a195762000a19620008d8565b500290565b6000821982111562000a345762000a34620008d8565b500190565b60008282101562000a4e5762000a4e620008d8565b500390565b634e487b7160e01b600052603260045260246000fd5b600181811c9082168062000a7e57607f821691505b60208210810362000a9f57634e487b7160e01b600052602260045260246000fd5b50919050565b60805160a05160c05160e05161010051610120516101405161209462000b006000396000610b0d0152600061134e0152600061139d01526000611378015260006112d1015260006112fb0152600061132501526120946000f3fe608060405234801561001057600080fd5b50600436106101c45760003560e01c8063715018a6116100f9578063a457c2d711610097578063d505accf11610071578063d505accf146103e2578063dd62ed3e146103f5578063f1127ed81461042e578063f2fde38b1461046b57600080fd5b8063a457c2d7146103a9578063a9059cbb146103bc578063c3cda520146103cf57600080fd5b80638da5cb5b116100d35780638da5cb5b1461036a5780638e539e8c1461037b57806395d89b411461038e5780639ab24eb01461039657600080fd5b8063715018a61461033c57806379cc6790146103445780637ecebe001461035757600080fd5b80633a46b1a811610166578063587cde1e11610140578063587cde1e146102945780635c19a95c146102d85780636fcfff45146102eb57806370a082311461031357600080fd5b80633a46b1a81461025957806340c10f191461026c57806342966c681461028157600080fd5b806323b872dd116101a257806323b872dd1461021c578063313ce5671461022f5780633644e5151461023e578063395093511461024657600080fd5b806306fdde03146101c9578063095ea7b3146101e757806318160ddd1461020a575b600080fd5b6101d161047e565b6040516101de9190611d11565b60405180910390f35b6101fa6101f5366004611d82565b610510565b60405190151581526020016101de565b6002545b6040519081526020016101de565b6101fa61022a366004611dac565b610526565b604051601281526020016101de565b61020e6105d5565b6101fa610254366004611d82565b6105e4565b61020e610267366004611d82565b610620565b61027f61027a366004611d82565b61069a565b005b61027f61028f366004611de8565b6106d2565b6102c06102a2366004611e01565b6001600160a01b039081166000908152600760205260409020541690565b6040516001600160a01b0390911681526020016101de565b61027f6102e6366004611e01565b6106df565b6102fe6102f9366004611e01565b6106e9565b60405163ffffffff90911681526020016101de565b61020e610321366004611e01565b6001600160a01b031660009081526020819052604090205490565b61027f610711565b61027f610352366004611d82565b610747565b61020e610365366004611e01565b6107cd565b6005546001600160a01b03166102c0565b61020e610389366004611de8565b6107eb565b6101d1610847565b61020e6103a4366004611e01565b610856565b6101fa6103b7366004611d82565b6108dd565b6101fa6103ca366004611d82565b610976565b61027f6103dd366004611e2d565b610983565b61027f6103f0366004611e85565b610ab9565b61020e610403366004611eef565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b61044161043c366004611f22565b610c1d565b60408051825163ffffffff1681526020928301516001600160e01b031692810192909252016101de565b61027f610479366004611e01565b610ca1565b60606003805461048d90611f62565b80601f01602080910402602001604051908101604052809291908181526020018280546104b990611f62565b80156105065780601f106104db57610100808354040283529160200191610506565b820191906000526020600020905b8154815290600101906020018083116104e957829003601f168201915b5050505050905090565b600061051d338484610fcc565b50600192915050565b60006105338484846110f0565b6001600160a01b0384166000908152600160209081526040808320338452909152902054828110156105bd5760405162461bcd60e51b815260206004820152602860248201527f45524332303a207472616e7366657220616d6f756e74206578636565647320616044820152676c6c6f77616e636560c01b60648201526084015b60405180910390fd5b6105ca8533858403610fcc565b506001949350505050565b60006105df6112c4565b905090565b3360008181526001602090815260408083206001600160a01b0387168452909152812054909161051d91859061061b908690611fac565b610fcc565b60004382106106715760405162461bcd60e51b815260206004820152601f60248201527f4552433230566f7465733a20626c6f636b206e6f7420796574206d696e65640060448201526064016105b4565b6001600160a01b038316600090815260086020526040902061069390836113eb565b9392505050565b6005546001600160a01b031633146106c45760405162461bcd60e51b81526004016105b490611fc4565b6106ce82826114a8565b5050565b6106dc33826114b2565b50565b6106dc33826114bc565b6001600160a01b03811660009081526008602052604081205461070b90610f29565b92915050565b6005546001600160a01b0316331461073b5760405162461bcd60e51b81526004016105b490611fc4565b6107456000611535565b565b60006107538333610403565b9050818110156107b15760405162461bcd60e51b8152602060048201526024808201527f45524332303a206275726e20616d6f756e74206578636565647320616c6c6f77604482015263616e636560e01b60648201526084016105b4565b6107be8333848403610fcc565b6107c883836114b2565b505050565b6001600160a01b03811660009081526006602052604081205461070b565b600043821061083c5760405162461bcd60e51b815260206004820152601f60248201527f4552433230566f7465733a20626c6f636b206e6f7420796574206d696e65640060448201526064016105b4565b61070b6009836113eb565b60606004805461048d90611f62565b6001600160a01b03811660009081526008602052604081205480156108ca576001600160a01b0383166000908152600860205260409020610898600183611ff9565b815481106108a8576108a8612010565b60009182526020909120015464010000000090046001600160e01b03166108cd565b60005b6001600160e01b03169392505050565b3360009081526001602090815260408083206001600160a01b03861684529091528120548281101561095f5760405162461bcd60e51b815260206004820152602560248201527f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f77604482015264207a65726f60d81b60648201526084016105b4565b61096c3385858403610fcc565b5060019392505050565b600061051d3384846110f0565b834211156109d35760405162461bcd60e51b815260206004820152601d60248201527f4552433230566f7465733a207369676e6174757265206578706972656400000060448201526064016105b4565b604080517fe48329057bfd03d55e49b547132e39cffd9c1820ad7b9d4c5307691425d15adf60208201526001600160a01b038816918101919091526060810186905260808101859052600090610a4d90610a459060a00160405160208183030381529060405280519060200120611587565b8585856115d5565b9050610a58816115fd565b8614610aa65760405162461bcd60e51b815260206004820152601960248201527f4552433230566f7465733a20696e76616c6964206e6f6e63650000000000000060448201526064016105b4565b610ab081886114bc565b50505050505050565b83421115610b095760405162461bcd60e51b815260206004820152601d60248201527f45524332305065726d69743a206578706972656420646561646c696e6500000060448201526064016105b4565b60007f0000000000000000000000000000000000000000000000000000000000000000888888610b388c6115fd565b6040805160208101969096526001600160a01b0394851690860152929091166060840152608083015260a082015260c0810186905260e0016040516020818303038152906040528051906020012090506000610b9382611587565b90506000610ba3828787876115d5565b9050896001600160a01b0316816001600160a01b031614610c065760405162461bcd60e51b815260206004820152601e60248201527f45524332305065726d69743a20696e76616c6964207369676e6174757265000060448201526064016105b4565b610c118a8a8a610fcc565b50505050505050505050565b60408051808201909152600080825260208201526001600160a01b0383166000908152600860205260409020805463ffffffff8416908110610c6157610c61612010565b60009182526020918290206040805180820190915291015463ffffffff8116825264010000000090046001600160e01b0316918101919091529392505050565b6005546001600160a01b03163314610ccb5760405162461bcd60e51b81526004016105b490611fc4565b6001600160a01b038116610d305760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b60648201526084016105b4565b6106dc81611535565b610d438282610dc9565b6002546001600160e01b031015610db55760405162461bcd60e51b815260206004820152603060248201527f4552433230566f7465733a20746f74616c20737570706c79207269736b73206f60448201526f766572666c6f77696e6720766f74657360801b60648201526084016105b4565b610dc36009610eb083611625565b50505050565b6001600160a01b038216610e1f5760405162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f20616464726573730060448201526064016105b4565b8060026000828254610e319190611fac565b90915550506001600160a01b03821660009081526020819052604081208054839290610e5e908490611fac565b90915550506040518181526001600160a01b038316906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200160405180910390a36106ce6000838361179e565b60006106938284611fac565b60006001600160e01b03821115610f255760405162461bcd60e51b815260206004820152602760248201527f53616665436173743a2076616c756520646f65736e27742066697420696e20326044820152663234206269747360c81b60648201526084016105b4565b5090565b600063ffffffff821115610f255760405162461bcd60e51b815260206004820152602660248201527f53616665436173743a2076616c756520646f65736e27742066697420696e203360448201526532206269747360d01b60648201526084016105b4565b6001600160a01b038381166000908152600760205260408082205485841683529120546107c8929182169116836117a9565b60006106938284611ff9565b6001600160a01b03831661102e5760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b60648201526084016105b4565b6001600160a01b03821661108f5760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b60648201526084016105b4565b6001600160a01b0383811660008181526001602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910160405180910390a3505050565b6001600160a01b0383166111545760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f206164604482015264647265737360d81b60648201526084016105b4565b6001600160a01b0382166111b65760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b60648201526084016105b4565b6001600160a01b0383166000908152602081905260409020548181101561122e5760405162461bcd60e51b815260206004820152602660248201527f45524332303a207472616e7366657220616d6f756e7420657863656564732062604482015265616c616e636560d01b60648201526084016105b4565b6001600160a01b03808516600090815260208190526040808220858503905591851681529081208054849290611265908490611fac565b92505081905550826001600160a01b0316846001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef846040516112b191815260200190565b60405180910390a3610dc384848461179e565b6000306001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614801561131d57507f000000000000000000000000000000000000000000000000000000000000000046145b1561134757507f000000000000000000000000000000000000000000000000000000000000000090565b50604080517f00000000000000000000000000000000000000000000000000000000000000006020808301919091527f0000000000000000000000000000000000000000000000000000000000000000828401527f000000000000000000000000000000000000000000000000000000000000000060608301524660808301523060a0808401919091528351808403909101815260c0909201909252805191012090565b8154600090815b8181101561144f57600061140682846118e6565b90508486828154811061141b5761141b612010565b60009182526020909120015463ffffffff16111561143b57809250611449565b611446816001611fac565b91505b506113f2565b81156114935784611461600184611ff9565b8154811061147157611471612010565b60009182526020909120015464010000000090046001600160e01b0316611496565b60005b6001600160e01b031695945050505050565b6106ce8282610d39565b6106ce8282611901565b6001600160a01b038281166000818152600760208181526040808420805485845282862054949093528787166001600160a01b03198416811790915590519190951694919391928592917f3134e8a2e6d97e929a7e54011ea5485d7d196dd5f0ba4d4ef95803e8e3fc257f9190a4610dc38284836117a9565b600580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b600061070b6115946112c4565b8360405161190160f01b6020820152602281018390526042810182905260009060620160405160208183030381529060405280519060200120905092915050565b60008060006115e687878787611919565b915091506115f381611a06565b5095945050505050565b6001600160a01b03811660009081526006602052604090208054600181018255905b50919050565b825460009081908015611670578561163e600183611ff9565b8154811061164e5761164e612010565b60009182526020909120015464010000000090046001600160e01b0316611673565b60005b6001600160e01b0316925061168c83858763ffffffff16565b91506000811180156116ca575043866116a6600184611ff9565b815481106116b6576116b6612010565b60009182526020909120015463ffffffff16145b1561172a576116d882610ebc565b866116e4600184611ff9565b815481106116f4576116f4612010565b9060005260206000200160000160046101000a8154816001600160e01b0302191690836001600160e01b03160217905550611795565b85604051806040016040528061173f43610f29565b63ffffffff16815260200161175385610ebc565b6001600160e01b0390811690915282546001810184556000938452602093849020835194909301519091166401000000000263ffffffff909316929092179101555b50935093915050565b6107c8838383610f8e565b816001600160a01b0316836001600160a01b0316141580156117cb5750600081115b156107c8576001600160a01b03831615611859576001600160a01b0383166000908152600860205260408120819061180690610fc085611625565b91509150846001600160a01b03167fdec2bacdd2f05b59de34da9b523dff8be42e5e38e818c82fdb0bae774387a724838360405161184e929190918252602082015260400190565b60405180910390a250505b6001600160a01b038216156107c8576001600160a01b0382166000908152600860205260408120819061188f90610eb085611625565b91509150836001600160a01b03167fdec2bacdd2f05b59de34da9b523dff8be42e5e38e818c82fdb0bae774387a72483836040516118d7929190918252602082015260400190565b60405180910390a25050505050565b60006118f56002848418612026565b61069390848416611fac565b61190b8282611bbc565b610dc36009610fc083611625565b6000807f7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a083111561195057506000905060036119fd565b8460ff16601b1415801561196857508460ff16601c14155b1561197957506000905060046119fd565b6040805160008082526020820180845289905260ff881692820192909252606081018690526080810185905260019060a0016020604051602081039080840390855afa1580156119cd573d6000803e3d6000fd5b5050604051601f1901519150506001600160a01b0381166119f6576000600192509250506119fd565b9150600090505b94509492505050565b6000816004811115611a1a57611a1a612048565b03611a225750565b6001816004811115611a3657611a36612048565b03611a835760405162461bcd60e51b815260206004820152601860248201527f45434453413a20696e76616c6964207369676e6174757265000000000000000060448201526064016105b4565b6002816004811115611a9757611a97612048565b03611ae45760405162461bcd60e51b815260206004820152601f60248201527f45434453413a20696e76616c6964207369676e6174757265206c656e6774680060448201526064016105b4565b6003816004811115611af857611af8612048565b03611b505760405162461bcd60e51b815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202773272076616c604482015261756560f01b60648201526084016105b4565b6004816004811115611b6457611b64612048565b036106dc5760405162461bcd60e51b815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202776272076616c604482015261756560f01b60648201526084016105b4565b6001600160a01b038216611c1c5760405162461bcd60e51b815260206004820152602160248201527f45524332303a206275726e2066726f6d20746865207a65726f206164647265736044820152607360f81b60648201526084016105b4565b6001600160a01b03821660009081526020819052604090205481811015611c905760405162461bcd60e51b815260206004820152602260248201527f45524332303a206275726e20616d6f756e7420657863656564732062616c616e604482015261636560f01b60648201526084016105b4565b6001600160a01b0383166000908152602081905260408120838303905560028054849290611cbf908490611ff9565b90915550506040518281526000906001600160a01b038516907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200160405180910390a36107c88360008461179e565b600060208083528351808285015260005b81811015611d3e57858101830151858201604001528201611d22565b81811115611d50576000604083870101525b50601f01601f1916929092016040019392505050565b80356001600160a01b0381168114611d7d57600080fd5b919050565b60008060408385031215611d9557600080fd5b611d9e83611d66565b946020939093013593505050565b600080600060608486031215611dc157600080fd5b611dca84611d66565b9250611dd860208501611d66565b9150604084013590509250925092565b600060208284031215611dfa57600080fd5b5035919050565b600060208284031215611e1357600080fd5b61069382611d66565b803560ff81168114611d7d57600080fd5b60008060008060008060c08789031215611e4657600080fd5b611e4f87611d66565b95506020870135945060408701359350611e6b60608801611e1c565b92506080870135915060a087013590509295509295509295565b600080600080600080600060e0888a031215611ea057600080fd5b611ea988611d66565b9650611eb760208901611d66565b95506040880135945060608801359350611ed360808901611e1c565b925060a0880135915060c0880135905092959891949750929550565b60008060408385031215611f0257600080fd5b611f0b83611d66565b9150611f1960208401611d66565b90509250929050565b60008060408385031215611f3557600080fd5b611f3e83611d66565b9150602083013563ffffffff81168114611f5757600080fd5b809150509250929050565b600181811c90821680611f7657607f821691505b60208210810361161f57634e487b7160e01b600052602260045260246000fd5b634e487b7160e01b600052601160045260246000fd5b60008219821115611fbf57611fbf611f96565b500190565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b60008282101561200b5761200b611f96565b500390565b634e487b7160e01b600052603260045260246000fd5b60008261204357634e487b7160e01b600052601260045260246000fd5b500490565b634e487b7160e01b600052602160045260246000fdfea264697066735822122011775a8f39e7ff1579b21725da158e11508c23365b9b3b718f4aebd50ce5437964736f6c634300080d0033dec2bacdd2f05b59de34da9b523dff8be42e5e38e818c82fdb0bae774387a724";

type SiloGovernanceTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SiloGovernanceTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SiloGovernanceToken__factory extends ContractFactory {
  constructor(...args: SiloGovernanceTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SiloGovernanceToken";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SiloGovernanceToken> {
    return super.deploy(overrides || {}) as Promise<SiloGovernanceToken>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): SiloGovernanceToken {
    return super.attach(address) as SiloGovernanceToken;
  }
  connect(signer: Signer): SiloGovernanceToken__factory {
    return super.connect(signer) as SiloGovernanceToken__factory;
  }
  static readonly contractName: "SiloGovernanceToken";
  public readonly contractName: "SiloGovernanceToken";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SiloGovernanceTokenInterface {
    return new utils.Interface(_abi) as SiloGovernanceTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SiloGovernanceToken {
    return new Contract(address, _abi, signerOrProvider) as SiloGovernanceToken;
  }
}
